import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.16009 9.27495L2.15997 6.07044C2.15995 5.26409 2.81361 4.6104 3.61995 4.6104L12.38 4.61033C13.1863 4.61033 13.84 5.26399 13.84 6.07032V9.27495M2.16009 9.27495H13.84M2.16009 9.27495L2.15997 12.6402C2.15994 13.4465 2.81361 14.1002 3.61996 14.1002H12.38C13.1863 14.1002 13.84 13.4466 13.84 12.6402V9.27495M8.10622 14.1002V4.61032M7.36994 4.303C7.47926 4.29851 7.58032 4.24103 7.63467 4.14689C7.68902 4.05276 7.68821 3.93647 7.63749 3.83958C7.44364 3.48632 6.7635 2.31172 6.31962 2.05544C5.76661 1.73616 5.05627 1.92455 4.73857 2.47483C4.42088 3.02507 4.61284 3.73445 5.1659 4.05376C5.61704 4.31422 6.96709 4.31175 7.36994 4.303ZM8.38608 3.83948C8.3353 3.9364 8.33455 4.05266 8.3889 4.1468C8.44325 4.24093 8.54436 4.29838 8.65363 4.3029C9.05649 4.31165 10.4138 4.30993 10.8577 4.05366C11.4107 3.73437 11.6027 3.02501 11.285 2.47473C10.9673 1.92449 10.257 1.73604 9.70395 2.05535C9.25281 2.31581 8.57992 3.48622 8.38608 3.83948Z",
  stroke: "currentColor",
  "stroke-width": "1.04",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }